import React from 'react';
import s from './RightAnswer.module.scss';

const RightAnswer = ({isCorrectTask, rightAnswer}) => {
    return isCorrectTask === false && <span className={s.answerRight}>Правильный ответ: {rightAnswer ?.map((answer) => answer + ', ')}</span>
}

export default RightAnswer;